import type { WorkspaceObject } from '@/types';
import { createNamedContext } from '@/utils';

export const WorkspaceBreadcrumbsContext = createNamedContext<WorkspaceObject[]>(undefined, 'Workspace.Breadcrumbs.Context');